var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompareNewVehicles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 1.29999C19.7 0.499988 19.0001 0 18.1001 0H8.8999C8.0999 0 7.3 0.499988 7 1.29999L5 7H3.8999C3.0999 7 2.3 7.49999 2 8.29999L0 14V22H3V21H14V22H17V14H19V15H22V7L20 1.29999ZM14 18H3V14.5L4.6001 10H12.3999L14 14.5V18ZM19 11H15.8999L14.8999 8.29999C14.5999 7.49999 13.9 7 13 7H8.1001L9.5 3H17.2998L19 7.5V11Z",
    fill: "#49B275"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareNewVehicles);
export default __webpack_public_path__ + "static/media/compare-new-vehicles.b981533295f647029fd52ebcfc5e3cb0.svg";
export { ForwardRef as ReactComponent };